import { render } from "./SettingsPermissions.vue?vue&type=template&id=3a5f2203&scoped=true"
import script from "./SettingsPermissions.vue?vue&type=script&lang=js"
export * from "./SettingsPermissions.vue?vue&type=script&lang=js"

import "./SettingsPermissions.vue?vue&type=style&index=0&id=3a5f2203&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5f2203"]])

export default __exports__